import { Notification, NotificationCategories, NotificationTypes } from '@core/domain/model/notifications/notification.model';
import { NotificationAction } from './notification.typing';
import { OptionMenu } from '@shared/ui-components/options-menu/options-menu.model';
import { ARCHIVE_OPTION, MARK_AS_READ_OPTION, UNARCHIVE_OPTION } from './notification.constants';
import { AcRoutingService } from '@core/services/routing/ac-routing.service';
import { Injectable } from '@angular/core';
import { procedureDetailPaths, procedurePaths } from '@core/domain/model/procedures/procedures-paths.model';

@Injectable()
export class NotificationConfig {
  constructor(private readonly _router: AcRoutingService) {}

  getAction(notification: Notification) {
    const actionsMap: Partial<Record<NotificationTypes, NotificationAction>> = {
      [NotificationTypes.PROCEDURE]: () => {
        return {
          text: `NOTIFICATIONS.ACTIONS.${NotificationTypes.PROCEDURE}`,
          clickLink: () =>
            this._router.goToMyProcedureDetailRoute(notification.crmCode!, procedureDetailPaths[notification.procedureTypeCode!]),
        };
      },
      [NotificationTypes.DRAFT]: () => {
        return {
          text: `NOTIFICATIONS.ACTIONS.${NotificationTypes.PROCEDURE}`,
          clickLink: () =>
            this._router.goToMyProcedureRoute(procedurePaths[notification.procedureTypeCode!], {
              draftId: notification.draftId!,
            }),
        };
      },
      [NotificationTypes.INVOICE]: () => ({
        text: `NOTIFICATIONS.ACTIONS.${NotificationTypes.INVOICE}`,
        clickLink: () => this._router.goToInvoice(notification.crmCode!),
      }),
      [NotificationTypes.ACCIONA_ENERGY]: () => ({
        text: `NOTIFICATIONS.ACTIONS.${NotificationTypes.ACCIONA_ENERGY}`,
        clickLink: () => {
          if (notification.crmCode) {
            this._router.goToNotificationsAnnouncement(notification.crmCode);
          }
        },
      }),
      [NotificationTypes.ERROR_CRM_PROCEDURE]: () => {
        return {
          text: `NOTIFICATIONS.ACTIONS.${NotificationTypes.ERROR_CRM_PROCEDURE}`,
          clickLink: () => this._router.goToProcedures(),
        };
      },
    };

    return actionsMap[notification.type]?.();
  }

  static getOptions(notification: Notification, category: NotificationCategories, cb: (optionId: string) => void) {
    const options: OptionMenu<string>[] = [];

    if ([NotificationCategories.ALL, NotificationCategories.URGENT, NotificationCategories.ALERT].includes(category)) {
      options.push({
        id: ARCHIVE_OPTION,
        label: `NOTIFICATIONS.OPTIONS.${ARCHIVE_OPTION}`,
        action: () => cb(ARCHIVE_OPTION),
      });
    } else {
      options.push({
        id: UNARCHIVE_OPTION,
        label: `NOTIFICATIONS.OPTIONS.${UNARCHIVE_OPTION}`,
        action: () => cb(UNARCHIVE_OPTION),
      });
    }

    if (!notification.isRead) {
      options.push({
        id: MARK_AS_READ_OPTION,
        label: `NOTIFICATIONS.OPTIONS.${MARK_AS_READ_OPTION}`,
        action: () => cb(MARK_AS_READ_OPTION),
      });
    }
    return options;
  }
}
